import APIClient from '@/shared/http/clients/api'

const resourceName = 'listacontato'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllByCampanhaListaPaging = (campanhalistaId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/campanhalista/${campanhalistaId}/?page=${index}&size=${limit}`, config)
const GetAllByListaInteligentePaging = (listaInteligenteId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?listaInteligenteId=${listaInteligenteId}&page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Import = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/importar/`, data, config)
const GetKpi = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/kpi`, data, config)

const ImportWithFilterCampanha = (listaInteligenteId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/importar/filtro/campanha/${listaInteligenteId}`, data, config)
const ImportWithFilterListaInteligente = (listaInteligenteId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/importar/filtro/lista-inteligente/${listaInteligenteId}`, data, config)

const ListaContatoRepository = {
  GetAll,
  GetAllPaging,
  GetAllByCampanhaListaPaging,
  GetAllByListaInteligentePaging,
  GetById,
  Create,
  Update,
  Delete,
  Import,
  GetKpi,
  ImportWithFilterCampanha,
  ImportWithFilterListaInteligente
}

export default ListaContatoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/listacontato.js